// pages/InvoicePaymentLog.js
import React, { useState, useEffect } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { API_URL, LOCATION_ID, TOKEN } from "..";
import { Spinner } from "react-bootstrap";
import { useParams } from "react-router-dom";
import PaymentLogsTable from "../components/PaymentLogsTable"; // new table component
import axios from "axios";

const InvoicePaymentLog = () => {
  const { invoiceId } = useParams(); // ✅ get invoice id from params
  const [loading, setLoading] = useState(true);
  const [paymentLogs, setPaymentLogs] = useState([]);

  useEffect(() => {
    const fetchPaymentLogs = async () => {
      try {
        const response = await fetch(`${API_URL}/api/payments/invoice/${invoiceId}`, {
          method: "GET",
          headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
          },
        });

        const data = await response.json();
        if (!response.ok) {
          console.error("Failed to fetch logs:", data.message);
          setPaymentLogs([]);
          return;
        }

        // ✅ Enhance logs with user info
        const logsWithUsers = await Promise.all(
          data.map(async (log) => {
            try {
                const options = {
                    method: 'GET',
                    url: 'https://services.leadconnectorhq.com/users/'+log.user_id,
                    headers: {
                      Authorization: `Bearer ${TOKEN}`,
                      Version: '2021-07-28',
                      Accept: 'application/json'
                    }
                  };
                  
                  try {
                    const { data } = await axios.request(options);
                    console.log(data);
                    return {
                        ...log,
                        userName: `${data.firstName || ""} ${data.lastName || ""}`.trim(),
                    };
                } catch (error) {
                    console.error(error);
                  }

            //   const userData = await userRes.json();
           
            } catch (err) {
              console.error("User fetch error:", err);
              return { ...log, userName: "Unknown User" };
            }
          })
        );

        setPaymentLogs(logsWithUsers);
      } catch (error) {
        console.error("Error fetching payment logs:", error);
        setPaymentLogs([]);
      } finally {
        setLoading(false);
      }
    };

    if (invoiceId) fetchPaymentLogs();
  }, [invoiceId]);

  return (
    <MasterLayout>
      <Breadcrumb title={`Payment Logs - Invoice #${invoiceId}`} />

      {loading && (
        <div className="text-center mt-4">
          <Spinner />
        </div>
      )}

      {!loading && paymentLogs.length === 0 && (
        <p className="text-center mt-3">No payment logs found for this invoice.</p>
      )}

      {!loading && paymentLogs.length > 0 && (
        <PaymentLogsTable logsData={paymentLogs} />
      )}
    </MasterLayout>
  );
};

export default InvoicePaymentLog;
